import {
  AfterContentInit,
  ContentChildren,
  Directive,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
} from '@angular/core';
import { Subscription } from 'rxjs';

import {
  ISortableGrid,
  ISortEventArgs,
  TSortDirections,
} from '../classes/grid-page-info';
import { NgbdSortableHeaderDirective } from './sort-by-header.directive';

@Directive({
  selector: 'thead[sortable]',
})
export class NgbdSortableColumnsDirective
  implements OnInit, OnDestroy, AfterContentInit
{
  @Input() grid?: ISortableGrid;
  @Input() directions?: TSortDirections;
  @Output() sort = new EventEmitter<ISortEventArgs>();

  @ContentChildren(NgbdSortableHeaderDirective, { descendants: true })
  headers: QueryList<NgbdSortableHeaderDirective>;

  subscriptions: Subscription = new Subscription();

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.directions = this.directions ?? this.grid?.sortDirections;
  }

  ngAfterContentInit() {
    if (!this.directions) {
      return;
    }

    for (const headerItem of this.headers) {
      headerItem.direction = this.directions[headerItem.sortBy.toString()];

      this.subscriptions.add(
        headerItem.direction$.subscribe((sortBy) => {
          for (const clh of this.headers) {
            clh.direction = clh.sortBy == sortBy.column ? sortBy.direction : '';
          }

          const directionsObject = this.directions as object;
          for (const key of Object.keys(directionsObject)) {
            directionsObject[key] = '';
          }
          directionsObject[sortBy.column.toString()] = sortBy.direction;

          const arr = sortBy.column.split('.');

          let obj;

          if (arr.length > 1) {
            const reversed = arr.reverse();
            for (const [index, element] of reversed.entries()) {
              obj = {
                [element]:
                  index === 0
                    ? directionsObject[sortBy.column.toString()]
                    : obj,
              };
            }
          }

          if (obj) {
            sortBy.column = obj;
          }

          if (this.grid) {
            this.grid.sort(sortBy);
          } else {
            this.sort.emit(sortBy);
          }
        }),
      );
    }
  }

  // private onSort(sortBy: ISortEventArgs){
  //   this.stateService.sort(sortBy);
  // }
}
